import React from "react";
import {useParams} from "react-router-dom";
import PortfolioTipcalculator from "./PortfolioTipcalculator";
import PortfolioEntertainment from "./PortfolioEntertainment";
import PortfolioInsure from "./PortfolioInsure";
import PortfolioFylo from "./PortfolioFylo";

const Project = ({handleMenuClick, projectsList}) => {
  const {projectName} = useParams();
  
  switch (projectName){
    case projectsList[0].title:
      return(<PortfolioTipcalculator handleMenuClick={handleMenuClick} project={projectsList[0]} previous={projectsList[3]} next={projectsList[1]} />);
      break;
    case projectsList[1].title:
      return(<PortfolioEntertainment handleMenuClick={handleMenuClick} project={projectsList[1]} previous={projectsList[0]} next={projectsList[2]} />);
      break;
    case projectsList[2].title:
      return(<PortfolioInsure handleMenuClick={handleMenuClick} project={projectsList[2]} previous={projectsList[1]} next={projectsList[3]} />);
      break;
    case projectsList[3].title:
      return(<PortfolioFylo handleMenuClick={handleMenuClick} project={projectsList[3]} previous={projectsList[2]} next={projectsList[0]} />);
      break;
  }
}

export default Project;